<div class="portlet-body mt-4">
  <!-- Skeleton Loader -->
  @if (loading) {
    <div class="skeleton-loader">
      <div class="card border-0 shadow">
        <div class="card-body p-0">
          <div class="d-flex justify-content-between align-items-center p-5 border-bottom">
            <div>
              <div class="skeleton" style="width: 320px; height: 28px; margin-bottom: 12px;"></div>
              <div class="skeleton" style="width: 500px; height: 14px;"></div>
            </div>
            <div class="skeleton" style="width: 180px; height: 44px; border-radius: 6px;"></div>
          </div>
          <div class="p-4">
            @for (i of [1,2,3,4]; track i) {
              <div class="mb-4">
                <div class="d-flex justify-content-between align-items-center p-3 border rounded-3 shadow-sm">
                  <div class="d-flex align-items-center flex-grow-1">
                    <div class="skeleton" style="width: 40px; height: 40px; border-radius: 50%; margin-right: 16px;"></div>
                    <div>
                      <div class="skeleton" style="width: 260px; height: 20px; margin-bottom: 8px;"></div>
                      <div class="skeleton" style="width: 400px; height: 12px; margin-bottom: 6px;"></div>
                      <div class="skeleton" style="width: 280px; height: 10px;"></div>
                    </div>
                  </div>
                  <div class="text-center ms-3">
                    <div class="skeleton" style="width: 40px; height: 28px; border-radius: 6px;"></div>
                    <div class="skeleton mt-1" style="width: 50px; height: 10px;"></div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (!loading) {
    <div class="card border-0 shadow">
      <div class="card-body p-0">
        <div
          class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center p-5 border-bottom">
          <div>
            <h1 class="h2 fw-bold mb-2">{{ 'systemEventsWorkflow.eventManagementSystem' | transloco }}</h1>
            <p class="mb-2 text-muted fs-6">
              {{ 'systemEventsWorkflow.eventManagementDescription' | transloco }}
            </p>
          </div>
          <button type="button" pButton pRipple class="p-button-outlined p-button-primary px-5 py-3 fs-6"
            (click)="showTemplateDialog()" [attr.aria-label]="'systemEventsWorkflow.addNewTrigger' | transloco" [pTooltip]="'systemEventsWorkflow.addNewTriggerTooltip' | transloco"
            tooltipPosition="bottom">
            <i class="pi pi-plus me-2"></i> {{ 'systemEventsWorkflow.addNewTrigger' | transloco }}
          </button>
        </div>
        <div class="mt-4">
          <!-- Accordion component allowing multiple open tabs -->
          <p-accordion [multiple]="true" class="mb-5">
            @for (event of workflowEventsTriggered; track event; let i = $index) {
              <p-accordionTab>
                <ng-template pTemplate="header">
                  <div
                    class="d-flex justify-content-between align-items-center w-100 p-3 bg-white rounded-3 border shadow-sm">
                    <div class="d-flex align-items-center flex-grow-1">
                      <!-- Event index badge -->
                      <span class="badge text-white me-3 fs-6 d-flex justify-content-center align-items-center"
                        style="background-color: #f79421; font-weight: 700; width: 40px; height: 40px; border-radius: 50%;">
                        {{ i + 1 }}
                      </span>
                      <div>
                        <!-- Event title -->
                        <h5 class="fw-bold mb-1 text-secondary">
                          {{ event.SystemEvent }}
                        </h5>
                        <!-- Event description -->
                        <small class="text-muted d-block">
                          {{ event.SystemEventDescription }}
                        </small>
                        <!-- Instruction to expand -->
                        <small class="text-muted fst-italic d-block mt-1" style="font-size: 0.75rem;">
                          {{ 'systemEventsWorkflow.clickToExpand' | transloco }}
                        </small>
                      </div>
                    </div>
                    <!-- Actions count badge -->
                    <div class="text-center ms-3">
                      <span class="badge text-white px-3 py-2 fs-6" style="background-color: #178d9b; font-weight: 700;">
                        {{ event.SystemEventTriggeredActionDtos.length || 0 }}
                      </span>
                      <small class="text-muted d-block mt-1">{{ 'systemEventsWorkflow.actions' | transloco }}</small>
                    </div>
                  </div>
                </ng-template>
                <!-- Accordion content -->
                <div class="p-2 rounded-3">
                  <!-- Actions header -->
                  <div class="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
                    <div>
                      <!-- Actions section title -->
                      <h3 class="fw-bold mb-2">{{ 'systemEventsWorkflow.currentActions' | transloco }}</h3>
                      <!-- Actions description -->
                      <small class="text-muted fs-7">
                        {{ 'systemEventsWorkflow.currentActionsDescription' | transloco }}
                      </small>
                    </div>
                    <!-- Button to add new action -->
                    <button type="button" pButton pRipple class="p-button-outlined p-button-primary px-4 py-2 fs-7"
                      (click)="addNewTriggerEventAction(event)" [attr.aria-label]="'systemEventsWorkflow.addNewAction' | transloco"
                      [pTooltip]="'systemEventsWorkflow.addNewActionTooltip' | transloco" tooltipPosition="bottom">
                      <i class="pi pi-plus me-1"></i> {{ 'systemEventsWorkflow.addNewAction' | transloco }}
                    </button>
                  </div>
                  <!-- Actions grid layout -->
                  <div class="row row-cols-1 row-cols-md-2 g-4">
                    <!-- Loop through actions -->
                    @for (action of event.SystemEventTriggeredActionDtos; track action) {
                      <div class="col">
                        <!-- Action card -->
                        <div class="card border-0 shadow-lg h-100 rounded">
                          <div class="card-body p-4 d-flex flex-column justify-content-between">
                            <div>
                              <!-- Action header with type and edit button -->
                              <div class="d-flex justify-content-between align-items-start mb-3">
                                <div class="d-flex flex-column align-items-start">
                                  <!-- Action type badge -->
                                  <span class="badge text-white px-3 py-2 fs-7 rounded-pill mb-2"
                                    [ngStyle]="{'background-color': '#f79421', 'font-weight': '700'}"
                                    [pTooltip]="'systemEventsWorkflow.actionTypeTooltip' | transloco" tooltipPosition="top">
                                    {{ action.SystemEventActionType }}
                                  </span>
                                  <!-- Instruction for editable actions -->
                                  @if (!((action.SystemEventActionEmailTemplateDto?.IsPredefined && action.SystemEventActionType === 'Email') ||
                                    (action.SmsTemplateDto?.EventTypeViewModel?.IsPredefined && action.SystemEventActionType === 'Sms'))) {
                                    <small
                                      class="text-muted fst-italic fs-8">
                                      {{ 'systemEventsWorkflow.clickEditIconAction' | transloco }}
                                    </small>
                                  }
                                </div>
                                <!-- Action controls -->
                                <div class="d-flex align-items-center gap-2">
                                  <!-- System generated badge -->
                                  @if (
                                    (action.SystemEventActionEmailTemplateDto?.IsPredefined && action.SystemEventActionType === 'Email') ||
                                    (action.SmsTemplateDto?.EventTypeViewModel?.IsPredefined && action.SystemEventActionType === 'Sms')
                                    ) {
                                    <span class="badge text-white px-3 py-2 fs-7 rounded-pill"
                                      style="background-color: #178d9b; font-weight: 700;"
                                      [pTooltip]="'systemEventsWorkflow.systemGeneratedTooltip' | transloco" tooltipPosition="top">
                                      {{ 'systemEventsWorkflow.systemGenerated' | transloco }}
                                    </span>
                                  }
                                  <!-- Edit action button -->
                                  @if (!((action.SystemEventActionEmailTemplateDto?.IsPredefined && action.SystemEventActionType === 'Email') ||
                                    (action.SmsTemplateDto?.EventTypeViewModel?.IsPredefined && action.SystemEventActionType === 'Sms'))
                                    ) {
                                    <button type="button" pButton pRipple class="p-button-outlined p-button-text p-button-rounded"
                                      (click)="editTriggerEventAction(action)" [pTooltip]="'systemEventsWorkflow.editActionTooltip' | transloco"
                                      tooltipPosition="left" [attr.aria-label]="'systemEventsWorkflow.editAction' | transloco">
                                      <i class="pi pi-pencil py-2"></i>
                                    </button>
                                  }
                                </div>
                              </div>
                              <!-- Template details based on action type -->
                              @switch (action.SystemEventActionType) {
                                <!-- Email action details -->
                                @case ('Email') {
                                  <div class="mb-3">
                                    <div class="card bg-white border rounded-4 p-3 shadow-sm">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <div class="flex-grow-1">
                                          <!-- Email template label -->
                                          <small class="text-muted fw-semibold text-uppercase d-block mb-2 fs-7">{{ 'systemEventsWorkflow.emailTemplate' | transloco }}</small>
                                          <!-- Email template name -->
                                          <h6 class="fw-bold mb-1 text-truncate" style="max-width: 250px;">
                                            {{ action.SystemEventActionEmailTemplateDto?.EmailEventName }}
                                          </h6>
                                          <!-- Instruction to edit email template -->
                                          <small class="text-muted fst-italic fs-8">{{ 'systemEventsWorkflow.clickEditEmailTemplate' | transloco }}</small>
                                        </div>
                                        <!-- Edit email template button -->
                                        @if (action.SystemEventActionEmailTemplateDto?.EmailTemplateId) {
                                          <button type="button" pButton pRipple
                                            class="p-button-outlined p-button-text p-button-rounded"
                                            (click)="showEditEmailTemplateDialog(action.SystemEventActionEmailTemplateDto?.EmailTemplateId!)"
                                            [pTooltip]="'systemEventsWorkflow.editEmailTemplate' | transloco" tooltipPosition="left"
                                            [attr.aria-label]="'systemEventsWorkflow.editEmailTemplate' | transloco">
                                            <i class="pi pi-pencil py-2"></i>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                                <!-- SMS action details -->
                                @case ('Sms') {
                                  <div class="mb-3">
                                    <div class="card bg-white border rounded-4 p-3 shadow-sm">
                                      <div class="d-flex justify-content-between align-items-center">
                                        <div class="flex-grow-1">
                                          <!-- SMS template label -->
                                          <small class="text-muted fw-semibold text-uppercase d-block mb-2 fs-7">{{ 'systemEventsWorkflow.smsTemplate' | transloco }}</small>
                                          <!-- SMS template name -->
                                          <h6 class="fw-bold mb-1 text-truncate" style="max-width: 250px;">
                                            {{ action.SmsTemplateDto?.EventTypeViewModel?.Name }}
                                          </h6>
                                          <!-- Instruction to edit SMS template -->
                                          <small class="text-muted fst-italic fs-8">{{ 'systemEventsWorkflow.clickEditSmsTemplate' | transloco }}</small>
                                          <!-- SMS template description -->
                                          <small class="text-muted fst-italic fs-8">{{
                                          action.SmsTemplateDto?.EventTypeViewModel?.Description }}</small>
                                        </div>
                                        <!-- Edit SMS template button -->
                                        @if (action.SmsTemplateDto?.Id) {
                                          <button type="button" pButton pRipple
                                            class="p-button-outlined p-button-text p-button-rounded"
                                            (click)="showEditSmsTemplateDialog(action.SmsTemplateDto?.Id!)"
                                            [pTooltip]="'systemEventsWorkflow.editSmsTemplate' | transloco" tooltipPosition="left" [attr.aria-label]="'systemEventsWorkflow.editSmsTemplate' | transloco">
                                            <i class="pi pi-pencil py-2"></i>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                                <!-- API call action details -->
                                @case ('Api Call') {
                                  <div class="mb-3">
                                    @if (action.SystemEventActionApiCallDto?.ApiName) {
                                      <div class="card bg-white border rounded-4 p-3 shadow-sm"
                                        >
                                        <!-- API configuration label -->
                                        <small class="text-muted fw-semibold text-uppercase d-block mb-2 fs-7">{{ 'systemEventsWorkflow.apiConfiguration' | transloco }}</small>
                                        <!-- API name -->
                                        <h6 class="fw-bold mb-1">{{ action.SystemEventActionApiCallDto?.ApiName }}</h6>
                                        <!-- API integration description -->
                                        <small class="text-muted fst-italic fs-8">{{ 'systemEventsWorkflow.apiIntegrationDescription' | transloco }}</small>
                                      </div>
                                    }
                                  </div>
                                }
                              }
                            </div>
                            <!-- Action footer -->
                            <div class="d-flex justify-content-between align-items-center pt-3 border-top">
                              <!-- Action date information -->
                              <div class="text-muted small fs-8">
                                @if (action.ModifiedDate) {
                                  <span class="fw-semibold">{{ 'systemEventsWorkflow.lastModified' | transloco }}</span>
                                  <span class="ms-1">{{ action.ModifiedDate | date: 'dd MMM yyyy' }}</span>
                                } @else {
                                  <span class="fw-semibold">{{ 'systemEventsWorkflow.created' | transloco }}</span>
                                  <span class="ms-1">{{ action.CreatedDate | date: 'dd MMM yyyy' }}</span>
                                }
                              </div>
                              <!-- Toggle switch for action activation -->
                              <div class="d-flex align-items-center bg-light rounded-pill px-3 py-2"
                                [pTooltip]="'systemEventsWorkflow.toggleActionTooltip' | transloco" tooltipPosition="left">
                                <span class="fw-semibold text-dark me-3 small">{{ 'systemEventsWorkflow.active' | transloco }}</span>
                                <p-inputSwitch [(ngModel)]="action.IsTrigger" (onChange)="onTriggerToggle(action)"
                                  (click)="$event.stopPropagation()" [attr.aria-label]="'systemEventsWorkflow.toggleActionActive' | transloco">
                                </p-inputSwitch>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <!-- No actions message -->
                  @if (!event.SystemEventTriggeredActionDtos || event.SystemEventTriggeredActionDtos.length === 0) {
                    <div
                      class="text-center py-5">
                      <h6 class="text-muted fw-semibold mb-2">{{ 'systemEventsWorkflow.noActionsConfigured' | transloco }}</h6>
                      <p class="text-muted small mb-3 fs-7">
                        {{ 'systemEventsWorkflow.noActionsDescription' | transloco }}
                      </p>
                      <!-- Button to add first action -->
                      <button type="button" pButton pRipple class="p-button-outlined p-button-primary px-4 py-2 fs-7"
                        (click)="addNewTriggerEventAction(event)" [attr.aria-label]="'systemEventsWorkflow.addFirstAction' | transloco"
                        [pTooltip]="'systemEventsWorkflow.addFirstActionTooltip' | transloco" tooltipPosition="bottom">
                        <i class="pi pi-plus me-1"></i> {{ 'systemEventsWorkflow.addFirstAction' | transloco }}
                      </button>
                    </div>
                  }
                </div>
              </p-accordionTab>
            }
          </p-accordion>
          <!-- No events message -->
          @if (!workflowEventsTriggered || workflowEventsTriggered.length === 0) {
            <div
              class="text-center py-5 bg-white rounded-4 shadow-lg">
              <h4 class="fw-bold mb-3">{{ 'systemEventsWorkflow.noEventsConfigured' | transloco }}</h4>
              <p class="text-muted mb-4 fs-6">
                {{ 'systemEventsWorkflow.noEventsDescription' | transloco }}
              </p>
              <!-- Button to create first event -->
              <button type="button" pButton pRipple class="p-button-outlined p-button-primary px-5 py-3 fs-6"
                (click)="showTemplateDialog()" [attr.aria-label]="'systemEventsWorkflow.createYourFirstEvent' | transloco"
                [pTooltip]="'systemEventsWorkflow.createFirstEventTooltip' | transloco" tooltipPosition="bottom">
                <i class="pi pi-plus me-2"></i> {{ 'systemEventsWorkflow.createYourFirstEvent' | transloco }}
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

<!-- Dialog for adding or editing triggers -->
<p-dialog [header]="(isEditMode ? 'systemEventsWorkflow.editSystemEventTrigger' : 'systemEventsWorkflow.addSystemEventTrigger') | transloco" [(visible)]="showDialog"
  [modal]="true" [style]="{ 'width': '700px', 'max-width': '95vw' }" [baseZIndex]="10000"
  [contentStyle]="{'max-height': '80vh', 'overflow-y': 'auto', 'overflow-x': 'visible'}">
  <div class="p-4">
    <!-- System event selection dropdown -->
    <div class="mb-4">
      <label class="form-label fw-bold mb-1">{{ 'systemEventsWorkflow.systemEvent' | transloco }}</label>
      <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.systemEventDescription' | transloco }}</small>
      <p-dropdown [options]="emailEvents" [(ngModel)]="selectedEmailEvent" [filter]="true" filterBy="label"
        optionLabel="label" [placeholder]="'systemEventsWorkflow.chooseSystemEvent' | transloco" (onChange)="onEmailEventChange()" appendTo="body"
        [disabled]="isDropdownDisabled" styleClass="w-100">
      </p-dropdown>
    </div>

    <!-- Action type selection dropdown -->
    <div class="mb-4">
      <label class="form-label fw-bold mb-1">{{ 'systemEventsWorkflow.actionType' | transloco }}</label>
      <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.actionTypeDescription' | transloco }}</small>
      <p-dropdown [options]="eventActionTypes" [(ngModel)]="selectedActionType" optionLabel="label"
        [disabled]="!selectedEmailEvent?.value || isEditMode" [placeholder]="'systemEventsWorkflow.selectActionType' | transloco"
        (onChange)="onActionTypeChange()" appendTo="body" styleClass="w-100">
      </p-dropdown>
    </div>

    <!-- API configuration section -->
    @if (isApiSelected) {
      <div class="card bg-light border-0 p-3 mb-4">
        <h6 class="fw-bold mb-1">{{ 'systemEventsWorkflow.apiConfiguration' | transloco }}</h6>
        <small class="text-muted d-block mb-3">{{ 'systemEventsWorkflow.apiConfigurationDescription' | transloco }}</small>
        <div class="row g-3">
          <!-- API name input -->
          <div class="col-12">
            <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.apiName' | transloco }}</label>
            <input type="text" class="form-control" [(ngModel)]="apiName"
              [placeholder]="'systemEventsWorkflow.apiNamePlaceholder' | transloco">
            </div>
            <!-- API endpoint input -->
            <div class="col-12">
              <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.apiEndpoint' | transloco }}</label>
              <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.apiEndpointDescription' | transloco }}</small>
              <input type="text" class="form-control" [(ngModel)]="apiEndpoint"
                placeholder="https://api.example.com/webhook">
              </div>
              <!-- HTTP method dropdown -->
              <div class="col-12">
                <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.httpMethod' | transloco }}</label>
                <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.httpMethodDescription' | transloco }}</small>
                <p-dropdown [options]="apiHttpMethod" [(ngModel)]="selectedApiMethod" [filter]="true" optionLabel="label"
                  [placeholder]="'systemEventsWorkflow.chooseHttpMethod' | transloco" (onChange)="onApiMethodChange($event)" appendTo="body"
                  styleClass="w-100">
                </p-dropdown>
              </div>
              <!-- Headers input -->
              <div class="col-12">
                <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.headers' | transloco }}</label>
                <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.headersDescription' | transloco }}</small>
                <textarea class="form-control" [(ngModel)]="apiHeaders" rows="3"
                placeholder='{"Authorization": "Bearer token"}'></textarea>
              </div>
              <!-- Request body input -->
              <div class="col-12">
                <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.requestBody' | transloco }}</label>
                <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.requestBodyDescription' | transloco }}</small>
                <textarea class="form-control" [(ngModel)]="apiRequestBodyTemplate" rows="3"
                placeholder='{"key": "value"}'></textarea>
              </div>
            </div>
          </div>
        }

        <!-- Email configuration section -->
        @if (isEmailSelected) {
          <div class="card bg-light border-0 p-3 mb-4">
            <h6 class="fw-bold mb-1">{{ 'systemEventsWorkflow.emailConfiguration' | transloco }}</h6>
            <small class="text-muted d-block mb-3">{{ 'systemEventsWorkflow.emailConfigurationDescription' | transloco }}</small>
            <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.emailTemplate' | transloco }}</label>
            <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.selectEmailTemplateDescription' | transloco }}</small>
            <p-dropdown [options]="EmailTemplates" [(ngModel)]="selectedEmailTemplate" [filter]="true"
              filterBy="EventTypeViewModel.Name" optionLabel="EventTypeViewModel.Name" [placeholder]="'systemEventsWorkflow.selectEmailTemplate' | transloco"
              appendTo="body" [ngModelOptions]="{ updateOn: 'change' }" styleClass="w-100">
            </p-dropdown>
          </div>
        }

        <!-- SMS configuration section -->
        @if (isSmsSelected) {
          <div class="card bg-light border-0 p-3 mb-4">
            <h6 class="fw-bold mb-1">{{ 'systemEventsWorkflow.smsConfiguration' | transloco }}</h6>
            <small class="text-muted d-block mb-3">{{ 'systemEventsWorkflow.smsConfigurationDescription' | transloco }}</small>
            <label class="form-label fw-semibold mb-1">{{ 'systemEventsWorkflow.smsTemplate' | transloco }}</label>
            <small class="text-muted d-block mb-2">{{ 'systemEventsWorkflow.selectSmsTemplateDescription' | transloco }}</small>
            <p-dropdown [options]="smsTemplates" [(ngModel)]="selectedSmsTemplate" [filter]="true"
              filterBy="EventTypeViewModel.Name" optionLabel="EventTypeViewModel.Name" [placeholder]="'systemEventsWorkflow.selectSmsTemplate' | transloco"
              appendTo="body" [ngModelOptions]="{ updateOn: 'change' }" (ngModelChange)="onSmsTemplateChange($event)"
              styleClass="w-100">
            </p-dropdown>
          </div>
        }

        <!-- Trigger toggle switch -->
        @if (isApiSelected || isEmailSelected || isSmsSelected) {
          <div class="d-flex align-items-center p-3 bg-light rounded-3"
            >
            <span class="fw-semibold me-3">{{ 'systemEventsWorkflow.triggerEvent' | transloco }}</span>
            <p-inputSwitch [(ngModel)]="isTrigger" (onChange)="onTriggerChange($event)" (click)="$event.stopPropagation()">
            </p-inputSwitch>
          </div>
        }
      </div>

      <!-- Dialog footer with buttons -->
      <ng-template pTemplate="footer">
        <div class="d-flex justify-content-end gap-3 p-3 border-top">
          <!-- Cancel button -->
          <button type="button" pButton pRipple class="p-button-outlined p-button-secondary" (click)="showDialog = false">
            {{ 'systemEventsWorkflow.cancel' | transloco }}
          </button>
          <!-- Save button -->
          <button type="button" pButton pRipple class="p-button-outlined p-button-primary"
            (click)="updateTriggerEventAction()">
            {{ 'systemEventsWorkflow.save' | transloco }}
          </button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Email template dialog component -->
    @if (isDisplayEmailTemplateDialog && selectedEmailTemplate) {
      <email-setting-template-dailog [displayDialog]="isDisplayEmailTemplateDialog" [emailEvents]="EmailEvents"
        [selectedEmailTemplate]="selectedEmailTemplate" [selectedEmailParameter]="selectedEmailParameter"
        [emailParameters]="emailParameters" [isEditMode]="isEditMode" (fetchEmailTemplate)="fetchEmailTemplates()"
        (onCloseEmailTemplateDailog)="onCloseEmailTemplateDialog($event)">
      </email-setting-template-dailog>
    }

    <!-- SMS template dialog component -->
    @if (isDisplaySmsTemplateDialog) {
      <sms-setting-template-dailog [displayDialog]="isDisplaySmsTemplateDialog" [emailEvents]="EmailEvents"
        [selectedSmsTemplate]="selectedSmsTemplate" [selectedEmailParameter]="selectedEmailParameter"
        [emailParameters]="emailParameters" [isEditMode]="isEditMode" (fetchEmailTemplate)="fetchAllSmsTemplates()"
        (onCloseEmailTemplateDailog)="onCloseSmsTemplateDialog($event)">
      </sms-setting-template-dailog>
    }